<template>

	<div class="container login-page site__block">
		<div class="row login-page__row align-content-center justify-content-center">
			<div class="col-10 col-lg-4">
				<login/>
			</div>
		</div>
	</div>
	
</template>

<script>
	import Login from '@/components/Login';
	import Vuex from 'vuex';


	export default {
		name: "LoginPage",
		components:{
			Login
		},
		computed:{
			...Vuex.mapGetters({
				user: 'user'
			}),
			redirect(){
				return this.$route.query.redirect ? this.$route.query.redirect: null;
			}
		},
		watch: {
			isLoggedIn(value) {
				if (value) {

					if(this.redirect){
						this.$router.push({path: this.redirect});
					}else{
						this.$router.push({name: 'stream'});
					}

				}
			}
		},
	}
</script>

<style lang="scss">

	.login-page{


		&__row{
			min-height: 400px;
		}
	}
</style>